export default __webpack_public_path__ + "static/media/two.367a8d6e.jpg";